import get from 'lodash/get'

export const isNotificationDateDialogOpen = (state) => get(state, ['vegetation', 'notification', 'open'])
export const isLoadingNotificationDate = (state) => get(state, ['vegetation', 'notification', 'loading'])
export const getNotificationDate = (state) => get(state, ['vegetation', 'notification', 'date'])
export const getNotificationDateSiteInspectionId = (state) => get(state, ['vegetation', 'notification', 'siteInspectionId'])


// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/notification.js